<template>
<div id="mainpost01" class="d-lg-flex position-relative">        
    <div class="container d-lg-flex align-items-lg-center content-space-t-3 content-space-lg-0 min-vh-lg-100">            
        <div class="w-100">                
            <div class="row">                    
                <div class="col-lg-5 maintext">                        
                    <h1>Financial Closing Automation</h1>                        
                    <span>회계 결산 자동화 솔루션</span>
                <div class="subinfo">                            
                    <h2>복잡한 기업 회계/재무 프로세스를 완벽히 자동화</h2>
                    <p>PA Soft는 대한민국 기업의 회계 결산 기준을 충실히 반영합니다.</p>
                    <h2>빠르고 효율적인 작업 방식</h2>                            
                    <p>반복적인 수동작업을 80% 이상 최소화하여 높은 업무 효율성을 확보합니다.</p>                            
                    <h2>보다 높은 정확성과 완성도</h2>                            
                    <p>정확하고 완성도 높은 결과물을 제공합니다.</p>                        
                </div>                                               
                </div>                                  
            </div>            
        </div>          
        <div class="col-lg-7 col-xl-6 d-none d-lg-block position-absolute top-0 end-0 pe-0">                    
            <img class="mainbg" src="@/assets/mainimg.jpg">
        </div>               
    </div>    
</div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.min-vh-lg-100 {min-height: 100vh!important;}
.mainbg {width:100%;
          margin-top:-1px;}
.maintext h1 {font-size:65px;
            font-family:sans-serif;
            font-weight:800; }
.maintext span {font-size:12px;
                font-family: sans-serif;
                font-weight:400;
                color: #fff;
                margin-bottom: 50px;
                background-color: #2b64b9;
                padding: 3px 10px;
                border-radius: 7px;}
.subinfo { margin-top: 100px;
            margin-bottom: 50px;}
.subinfo h2 { margin-top: 10px;
              margin-bottom: 8px;
              font-size: 18px;
              font-weight:600;}
.subinfo p { margin-bottom: 40px;
            font-size: 14px;
            font-weight:500;
            color:#62778d}

</style>
